import React, { useEffect } from "react";

const KitFormEmbed = () => {
  useEffect(() => {
    // Check if the script is already added
    const scriptId = "kit-form-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.dataset.uid = "019cd0a724"; // Attach the data-uid attribute
      script.src = "https://theblocks.kit.com/019cd0a724/index.js";

      // Append the script to the section container
      const container = document.getElementById("kit-form-section");
      if (container) {
        container.appendChild(script);
      }
    }
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  return (
    <section id="kit-form-section">
      {/* The form will be injected here */}
    </section>
  );
};

export default KitFormEmbed;
